export default "__VITE_ASSET__1a0afb09__"